const poland_flag = require("./flags/poland.png");
const united_kingdom_flag = require("./flags/united_kingdom.png");
const germany_flag = require("./flags/germany.png");

export { poland_flag, united_kingdom_flag, germany_flag };
